import React from 'react';
import GamificationTab from '../components/intelligence/GamificationTab';

// Standalone Achievements page — MC (agent) sidebar destination.
// Same content as the old Achievements dashboard tab, unchanged.
export default function AchievementsPage() {
  return (
    <div className="space-y-6" data-testid="achievements-page">
      <div>
        <h1 className="text-4xl font-bold text-slate-900 mb-1" style={{ fontFamily: 'Outfit' }}>
          Achievements
        </h1>
        <p className="text-slate-500 text-sm">Your XP, badges and team recognition</p>
      </div>
      <GamificationTab />
    </div>
  );
}
